import { createActions } from 'redux-arc'

export const { types, creators } = createActions('app', {
  getSalesPartnerRequest: null,
  getSalesPartnerSucceeded: null,
  getSalesPartnerFailed: null,
})
